let module = {};

/**
 * Container Initialization
 */
module.init = function () {
    let gallery = document.querySelector('.spectra-image-gallery');
    let body = document.querySelector('body');
    if ( gallery ) {
        body.classList.add('page-has-spectra-gallery-modal');
    }
};

document.addEventListener("DOMContentLoaded", () => {
    module.init();
});
